// @flow
import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { router } from '../routes/router';
import { blockedRedirect } from '../routes/blockedAccess';

import type { User, AuthState } from '../types';
import { ErrorBoundaryView } from '@blocks';

type Props = {
  auth: AuthState,
  user: User,
  dispatch: Function,
  history: Object,
  clinics: Object,
};

export function requireAuth(Component: Object, path: string) {
  class AuthenticatedRoute extends React.Component<Props> {
    componentWillMount() {
      this.checkAuth();
    }

    // The new props: checking the old ones sent a user away for the state they just left (a paid account
    // still blocked once more after its refresh)
    componentWillReceiveProps(nextProps: Props) {
      this.checkAuth(nextProps);
    }

    render() {
      const isAuthenticated = get(this.props, ['auth', 'authenticated']);
      return (
        <ErrorBoundaryView>
          {(isAuthenticated === 'user') ? <Component {...this.props} /> : null}
        </ErrorBoundaryView>
      );
    }

    checkAuth(props: Props = this.props) {
      const { user, auth, clinics } = props;
      const authenticationInProgress = get(auth, 'inProgress');
      const isAuthenticated = get(auth, 'authenticated');
      const userName = get(user, 'name');
      const userEmail = get(user, 'email');
      const advancedData = get(user, 'advancedData', null);
      const userProfession = get(user, 'professionCode');
      const userRole = get(user, 'roleType');
      const blocked = get(advancedData, 'blocked', false);
      const subscriptionStatus = get(advancedData, 'subscriptionStatus', false);
      const haveActiveClinic = !!get(clinics, ['activeClinic', 'id'], null);
      const clinicLoading = !!get(clinics, ['isLoading'], false);

      const blockedTo = blockedRedirect({ blocked, subscriptionStatus, path });

      if (!isAuthenticated) {
        if (window.isCordovaApp) {
          props.dispatch(router.pushPath('appHome'));
        } else {
          props.dispatch(router.pushPath('login'));
        }
      }

      // Check registration process step data and redirect to specific step depending on criteria
      // - step 1 - email
      // - step 2 - username
      // - step 3 - profession
      if (isAuthenticated && userEmail && !userName) {
        props.dispatch(router.pushPath('signUpBasic'));
      } else if (isAuthenticated && !authenticationInProgress && userEmail && userName && !userProfession && (userRole !== 'Secretary')) {
        props.dispatch(router.pushPath('signUpProfession'));
      } else if (isAuthenticated && !authenticationInProgress && userEmail && userName && (userProfession || (userRole === 'Secretary')) && !advancedData) {
        props.dispatch(router.pushPath('newClinic'));
      } else if (isAuthenticated && blockedTo) {
        // Replaced, not pushed: "back" (the arrow, Android's button) then skips the closed page instead
        // of landing on it and being sent here again
        props.dispatch(router.replacePath(blockedTo));
      } if (!haveActiveClinic && userProfession && advancedData && isAuthenticated && !authenticationInProgress && path !== '/cadastro/clinica' && !clinicLoading) {
        props.dispatch(router.pushPath('newClinic'));
        return path === '/cadastro/clinica/nova';
      }
    }
  }

  const mapStateToProps: any = (state) => ({
    auth: state.auth,
    user: state.context.user,
    clinics: state.context.clinics,
  });

  const connected: any = connect<any, any, any, any, any, any>(mapStateToProps);

  const gated: any = connected(AuthenticatedRoute);
  // Marks the pages that need a login, for the test that keeps app.routes.js's `open` flags in step
  gated.requiresAuth = true;
  return gated;
}
